import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import { theme } from 'theme';
import MemberCodeIcon from 'assets/icons/Membercode.svg?react';
import { VideoIdentificationForm } from 'views/VideoIdentification/VideoIdentificationForm';
import { Form, Formik } from 'formik';
import { VideoIdentificationFormType } from 'types';
import { LanguageEnum } from 'pco-product-service-internal-consumer';
import { videoIdentificationValidationSchema } from './videoIdentificationValidationSchema';
import { useSelector } from 'react-redux';
import { selectVIData } from 'selectors/videoIdentificationSelector';
import { formatEnum } from 'utils/stringUtils';
import { VideoIdentificationFormActions } from 'views/VideoIdentification/VideoIdentificationFormActions';
import { jbColors } from 'theme/jbColors';

export const VideoIdentificationFormContainer = () => {
  const formDataFromState = useSelector(selectVIData);
  const mobileNumbers = formDataFromState?.mobileNumbers?.map((mobile) => mobile.mobileNumber ?? '');
  const eMailAddresses = formDataFromState?.emailAddresses?.map((email) => email.eMail ?? '');

  const initialValues: VideoIdentificationFormType = {
    name: {
      firstName: formDataFromState?.name?.firstName ?? '',
      middleName: formDataFromState?.name?.middleName ?? '',
      lastName: formDataFromState?.name?.lastName ?? '',
      gender: formDataFromState?.name?.gender ? formatEnum(formDataFromState?.name?.gender) : '',
    },
    nationalities: formDataFromState?.nationalities?.length === 1 ? formDataFromState?.nationalities[0] : '',
    mobileNumbers:
      formDataFromState?.mobileNumbers?.length === 1
        ? (formDataFromState.mobileNumbers[0].mobileNumber ?? '')
        : (formDataFromState?.mobileNumbers?.find((mobile) => mobile.primary)?.mobileNumber ?? ''),
    eMailAddresses:
      formDataFromState?.emailAddresses?.length === 1
        ? (formDataFromState?.emailAddresses[0].eMail ?? '')
        : (formDataFromState?.emailAddresses?.find((email) => email.primary)?.eMail ?? ''),
    dateOfBirth: formDataFromState?.dateOfBirth?.toISOString() ?? '',
    address: {
      city: formDataFromState?.address?.city ?? '',
      country: formDataFromState?.address?.country ?? '',
      street: formDataFromState?.address?.street ?? '',
      zip: formDataFromState?.address?.zip ?? '',
    },
    businessRelationshipNumbers:
      formDataFromState?.businessRelationshipNumbers?.length === 1
        ? formDataFromState?.businessRelationshipNumbers[0]
        : '',
    language: LanguageEnum.En,
    legalInformation: false,
    generalBankingConditions: false,
    clmUserInfo: {
      emailAddress: formDataFromState?.clmUserInfo?.emailAddress ?? '',
      fullName: formDataFromState?.clmUserInfo?.fullName ?? '',
      uNumber: formDataFromState?.clmUserInfo?.uNumber ?? '',
    },
    advisoryLocationConfirmation: false,
  };

  return (
    <Grid
      data-testid="video-identification-form-container"
      style={{
        paddingLeft: theme.spacing(4),
        backgroundColor: jbColors.core.stone[30],
        marginTop: '-1.5em',
      }}
    >
      <Typography variant="h1">VIDEO IDENTIFICATION</Typography>
      <Card
        id={'initiate-video-identification-form'}
        style={{ maxWidth: '90%', marginBottom: theme.spacing(15) }}
        square
      >
        <Grid container style={{ paddingLeft: theme.spacing(2) }}>
          <MemberCodeIcon style={{ marginTop: theme.spacing(2) }} />
          <CardHeader
            title={'Define context'}
            titleTypographyProps={{ variant: 'subtitle1' }}
            style={{
              paddingBottom: theme.spacing(1),
              paddingLeft: theme.spacing(1),
            }}
          />
        </Grid>
        <CardContent style={{ paddingTop: theme.spacing(1) }}>
          <Formik
            validateOnBlur
            validateOnChange
            validateOnMount={true}
            initialValues={initialValues}
            validationSchema={videoIdentificationValidationSchema}
            enableReinitialize
            onSubmit={() => console.log()}
          >
            <Form>
              <VideoIdentificationForm
                businessRelationshipNumbers={formDataFromState?.businessRelationshipNumbers}
                nationalities={formDataFromState?.nationalities}
                mobileNumbers={mobileNumbers}
                eMailAddresses={eMailAddresses}
              />
              {/*<pre>{ JSON.stringify(values, null, 2) }</pre>*/}
              {/*<pre style={ { color: 'red' } }>{ JSON.stringify(errors, null, 2) }</pre>*/}
              <VideoIdentificationFormActions />
            </Form>
          </Formik>
        </CardContent>
      </Card>
    </Grid>
  );
};
